export default (function () {
  $(document).ready(function () {
    $('#wpmem_login_form #log').attr('placeholder', 'Benutzername');
    $('#wpmem_login_form #pwd').attr('placeholder', 'Passwort');
    var $bgIframeHeight;
    $bgIframeHeight = $('.iframe-wrapper__device').height();
    $('.iframe-wrapper__device').height($bgIframeHeight / 2);
  });
});